import { api } from '../lib/api';
import type { CreditNote } from '../types/api';

export interface CreditNoteLineInput {
  siteId: string;
  description: string;
  netAmount: number;
  vatAmount?: number;
}

export interface CreateCreditNoteInput {
  invoiceId?: string;
  reason: string;
  lines: CreditNoteLineInput[];
}

// §20: MSP Admin only to issue - matches CreditNotesController on the backend.
export async function createCreditNote(orgId: string, input: CreateCreditNoteInput): Promise<CreditNote> {
  const { data } = await api.post<CreditNote>(`/customer-organisations/${orgId}/credit-notes`, input);
  return data;
}

export async function listCreditNotes(customerOrganisationId?: string): Promise<CreditNote[]> {
  const params = customerOrganisationId ? `?customerOrganisationId=${customerOrganisationId}` : '';
  const { data } = await api.get<CreditNote[]>(`/credit-notes${params}`);
  return data;
}

export async function getCreditNote(id: string): Promise<CreditNote> {
  const { data } = await api.get<CreditNote>(`/credit-notes/${id}`);
  return data;
}

export async function voidCreditNote(id: string): Promise<CreditNote> {
  const { data } = await api.patch<CreditNote>(`/credit-notes/${id}/void`, {});
  return data;
}
